const firebaseConfig = {
    apiKey: "AIzaSyAROqEvbdBHK7E0wxbWfeRlJ0BWilXZiec",
    authDomain: "ema-john-simple-react.firebaseapp.com",
    databaseURL: "https://ema-john-simple-react.firebaseio.com",
    projectId: "ema-john-simple-react",
    storageBucket: "ema-john-simple-react.appspot.com",
    messagingSenderId: "503886352649",
    appId: "1:503886352649:web:a954b98bc91913e21883d8"
};

export default firebaseConfig;